module.exports = __webpack_public_path__ + "static/media/right-arrow.4e26d9f8.svg";